<template>
  <div class="event-detail-page">
    <a-spin :spinning="loading">
      <div v-if="event.id" class="detail-container">
        <div class="hero">
          <img v-if="event.cover" :src="getFileAccessHttpUrl(event.cover)" :alt="event.eventName" />
          <div v-else class="hero-empty">暂无封面</div>
        </div>
        <div class="main">
          <div class="title-row">
            <div>
              <h1>{{ event.eventName }}</h1>
              <div class="time">{{ event.startTime }} 至 {{ event.endTime }}</div>
            </div>
            <a-button type="primary" size="large" :disabled="buttonDisabled" @click="goSignup">
              {{ buttonText }}
            </a-button>
          </div>
          <div class="summary">{{ event.summary }}</div>
          <div class="meta">
            <span>剩余名额：{{ remainingText }}</span>
          </div>
          <div class="detail-section">
            <h2>活动详情</h2>
            <div class="rich-content" v-html="event.content"></div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, getFileAccessHttpUrl } from '@/api/manage'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'EventDetail',
  data() {
    return {
      loading: false,
      event: {},
      signupDetail: null
    }
  },
  computed: {
    remainingText() {
      return this.event.remainingNum === null || this.event.remainingNum === undefined ? '不限' : this.event.remainingNum
    },
    buttonDisabled() {
      if (!this.event.id) return true
      if (this.event.remainingNum !== null && this.event.remainingNum !== undefined && this.event.remainingNum <= 0 && !this.signupDetail) return true
      if (this.signupDetail && this.signupDetail.signup && Number(this.signupDetail.signup.auditStatus) === 1) return true
      return false
    },
    buttonText() {
      if (this.event.remainingNum !== null && this.event.remainingNum !== undefined && this.event.remainingNum <= 0 && !this.signupDetail) return '名额已满'
      if (this.signupDetail && this.signupDetail.signup) {
        const status = Number(this.signupDetail.signup.auditStatus)
        if (status === 1) return '已通过'
        if (status === 2) return '修改报名'
        return '查看/修改报名'
      }
      return '立即报名'
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    getFileAccessHttpUrl,
    loadData() {
      const id = this.$route.query.id
      if (!id) {
        this.$message.warning('参数错误')
        this.$router.go(-1)
        return
      }
      this.loading = true
      getAction('/xjtech/event/public/detail', { id }).then(res => {
        if (res.success) {
          this.event = res.result.event || {}
          this.loadMySignup()
        } else {
          this.$message.warning(res.message || '获取活动失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadMySignup() {
      if (!Vue.ls.get(ACCESS_TOKEN)) {
        return
      }
      getAction('/xjtech/eventSignup/myDetail', { eventId: this.event.id }).then(res => {
        if (res.success && res.result && res.result.signup) {
          this.signupDetail = res.result
        }
      })
    },
    goSignup() {
      if (!Vue.ls.get(ACCESS_TOKEN)) {
        this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
        return
      }
      this.$router.push({ path: '/event/signup', query: { id: this.event.id } })
    }
  }
}
</script>

<style scoped lang="less">
.event-detail-page {
  max-width: 1100px;
  margin: 0 auto;
}
.detail-container {
  background: #fff;
}
.hero {
  height: 320px;
  background: #f5f5f5;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.hero-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
.main {
  padding: 28px;
}
.title-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  h1 {
    margin: 0 0 8px;
    font-size: 30px;
    color: #1f1f1f;
  }
}
.time,
.meta {
  color: #666;
}
.summary {
  margin: 20px 0;
  color: #333;
  line-height: 1.8;
}
.detail-section {
  margin-top: 28px;
  h2 {
    font-size: 22px;
    margin-bottom: 16px;
  }
}
.rich-content {
  line-height: 1.9;
}
</style>
